import React from "react";
import styled from "styled-components";
import LogoWithText from "../../assets/logo/LogoWithTextLight.png";

export default function Footer({ navigate }) {
  const getCurrentYear = () => new Date().getFullYear();

  return (
    <Wrapper>
      <div className="sunriseBar" />
      <div className="footerWash">
        <div className="container">
          {/* Legal links row */}
          <LegalRow>
            <LegalLink onClick={() => navigate("privacy")} className="font13">
              מדיניות פרטיות
            </LegalLink>
            <Dot>·</Dot>
            <LegalLink onClick={() => navigate("terms")} className="font13">
              תנאי שימוש
            </LegalLink>
            <Dot>·</Dot>
            <LegalLink onClick={() => navigate("accessibility")} className="font13">
              הצהרת נגישות ♿
            </LegalLink>
          </LegalRow>

          {/* Main footer row */}
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "20px 0 30px" }}>
            <LogoBtn onClick={() => navigate && navigate("home")} className="pointer flexNullCenter">
              <img src={LogoWithText} alt="הלב הצבעוני" height="40" />
            </LogoBtn>
            <StyleP className="whiteColor font13">
              © {getCurrentYear()} הלב הצבעוני | כל הזכויות שמורות
            </StyleP>
            <BackToTop
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="whiteColor animate pointer font13"
            >
              חזרה למעלה ↑
            </BackToTop>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  direction: rtl;
`;
const LegalRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  padding: 20px 0 0;
  border-bottom: 1px solid rgba(255, 167, 236, 0.2);
  flex-wrap: wrap;
`;
const LegalLink = styled.button`
  background: transparent;
  border: none;
  color: var(--candy);
  cursor: pointer;
  padding: 4px 6px;
  transition: color 0.3s var(--ease-out);
  &:hover { color: #fff; }
`;
const Dot = styled.span`
  color: var(--rose-300);
  font-size: 0.75rem;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
    gap: 15px;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 10px 0;
  }
`;
const LogoBtn = styled.button`
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  cursor: pointer;
`;
const BackToTop = styled.button`
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  &:hover { color: var(--candy) !important; transform: translateY(-3px); }
`;
